export default "__VITE_ASSET__BOIWhQ0V__"